import { Button } from "@/components/ui";
import type { AgentAnswer } from "@/lib/attributeReview/reviewRow.types";
import { pathLabel } from "@/lib/attributeReview/pathLabel";
import { cn } from "@/lib/utils";

import { box, muted } from "./agentStyles";

export type AgentAnswerCardProps = {
  name: string;
  answer: AgentAnswer;
  pickedPath: string | null;
  pickedKind: string | null;
  labelOf: (path: string) => string;
  onUse?: (path: string | null, kind?: string | null) => void;
  usedTitle?: string;
};

export function AgentAnswerCard({
  name,
  answer,
  pickedPath,
  pickedKind,
  labelOf,
  onUse,
  usedTitle,
}: AgentAnswerCardProps) {
  if (!answer.path && !answer.kind) return null;
  const path = answer.path;
  const selected =
    path === pickedPath && (path !== null || answer.kind === pickedKind);
  return (
    <div
      className={cn(
        box,
        selected && "border-indigo-400 ring-1 ring-inset ring-indigo-400",
      )}
    >
      <div className={cn("flex w-full justify-between gap-2 text-xs", muted)}>
        <span>{name}</span>
        {answer.confidence !== null && (
          <span>{Math.round(answer.confidence * 100)}% sure</span>
        )}
      </div>
      <p className="text-[15px] font-semibold text-slate-900 dark:text-slate-50">
        {path ? pathLabel(labelOf, path) : answer.kind}
      </p>
      {path ? (
        <p className="break-all font-mono text-xs text-slate-500 dark:text-slate-400">
          {path}
        </p>
      ) : (
        <p className={muted}>No field for the seller.</p>
      )}
      {usedTitle && (
        <p className="text-xs text-slate-600 dark:text-slate-300">
          {usedTitle}
        </p>
      )}
      {onUse && (
        <Button
          size="sm"
          variant="outline"
          disabled={selected}
          onClick={() => onUse(path, answer.kind)}
        >
          {selected ? "Picked" : "Pick this"}
        </Button>
      )}
    </div>
  );
}
